import React, { useCallback, useMemo, useState } from "react";
import VStack from "../../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing";
import type { Meta, StoryObj } from "@storybook/react";
import { createStackNavigator } from "@react-navigation/stack";
import SignupSigninStack, { SignupSigninScreens } from "../../../navigations/SignupSigninStack";
import { GET_DEFAULT_PROFILE_TYPE } from "../../../graphql/identity";
import { MockedAuthManager } from "../../../contexts/AuthManager";
import { User } from "../../../__generated__/graphql";
import { FirebaseAuthTypes } from "@react-native-firebase/auth";

type StoryStackParams = {
    SignupSigninStack?: { isSignup?: boolean; initialRouteName?: SignupSigninScreens };
};

const Stack = createStackNavigator<StoryStackParams>();

const StoryComponent = ({ isSignup = false }: { isSignup?: boolean }) => {
    const [user, setUser] = useState<User | null>();

    const mocks = useMemo(
        () => [
            {
                variableMatcher: () => true,
                request: {
                    query: GET_DEFAULT_PROFILE_TYPE,
                },
                newData: () => ({
                    data: {
                        getDefaultProfileType: null,
                    },
                }),
            },
        ],
        [],
    );

    const signInWithPhoneNumber = useCallback<
        (phoneNumber: string) => Awaited<FirebaseAuthTypes.ConfirmationResult>
    >(() => {
        return {
            verificationId: null,
            confirm: (code: string) => {
                switch (code) {
                    case "111111":
                        setUser(null);
                        break;
                    case "222222":
                        setUser(null);
                        break;
                    case "333333":
                        setUser(null);
                        break;
                    default:
                        setUser(null);
                        break;
                }
                return {} as Promise<FirebaseAuthTypes.UserCredential>;
            },
        };
    }, []);

    return (
        <MockedAuthManager user={user} signInWithPhoneNumber={signInWithPhoneNumber}>
            <MockedProvider mocks={mocks}>
                <VStack gap={1} style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}>
                    <Stack.Navigator initialRouteName="SignupSigninStack">
                        <Stack.Screen
                            name="SignupSigninStack"
                            component={SignupSigninStack}
                            initialParams={{ isSignup }}
                            options={{
                                headerShown: false,
                                gestureEnabled: false,
                            }}
                        />
                    </Stack.Navigator>
                </VStack>
            </MockedProvider>
        </MockedAuthManager>
    );
};

const meta = {
    title: "SignupSignin/FULL",
    component: StoryComponent,
    argTypes: {
        isSignup: {
            control: {
                type: "boolean",
            },
        },
    },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Signup: Story = {
    args: {
        isSignup: true,
    },
};
export const Signin: Story = {
    args: {
        isSignup: false,
    },
};
